import ResumeCard from "./ResumeCard";

export default ResumeCard;
